import { AlertLineOrderedsuggestedNoteDTO } from "src/models/alert-line-suggested-note/alert-line-ordered-suggested-note-dto";
import { STOModel } from "src/models/base/sto-model";
import { BaseApiService } from "../base";

export class AlertLineOrderedSuggestedNotesApiService extends BaseApiService<
  AlertLineOrderedsuggestedNoteDTO,
  STOModel
> {
  constructor() {
    super({
      servicePath: "/AlertLine",
      loadItemsPath: "/GetAlertLineOrderedSuggestedNotes",
    });
  }
}
